import { SocieteCaracteristiqueSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteCaracteristiqueModel: SelectorModel = {
  name: 'societeCaracteristiques',
  getSelector: SocieteCaracteristiqueSelectors.selectAllSocieteCaracteristiquesDictionary,
  isReady: SocieteCaracteristiqueSelectors.selectIsReadySocieteCaracteristique
};
